import React, { Component } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Fetcher } from '../../Helpers/fetcher.js';
import { Notify } from '../../Helpers/notification.js';
import { isEmpty } from 'lodash';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { withRouter } from "react-router-dom";

class Login extends Component {
    constructor(props) {
        super(props);
        this.origin = window.location.origin;
        this.state = {
            username: '',
            password: '',
            showPassword: false,
        };
    }

    setvalue = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState({
            [name]: type === 'checkbox' ? checked : value
        });
    }

    togglePasswordVisibility = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }

    loginUser = (e) => {
        e.preventDefault();
        const { username, password } = this.state;
        if (!username || !password) return Notify.notify('Please enter username & password');

        const data = { username, password };
        Fetcher.post(this.props.app.apiPath + '/api/obd/login', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(res => {
                if (res.message === 'Bad credentials') Notify.notify('Wrong username or password');
                else if (!isEmpty(res.token) && !isEmpty(res.userid)) {
                    Notify.notify('Login Successful');
                    this.props.setUserToken(res.userid, res.token, res.role);
                    if (res.role.includes('ROLE_SUSER')) this.props.history.push("/sub-user-report");
                } else Notify.notify('Login Failed');
            })
            .catch(err => {
                console.error('Login error:', err);
                Notify.notify('Login Failed');
            });
    }

    render() {
        const { showPassword } = this.state;

        return (
            <div className="auth-page">
                {/* Left — brand panel */}
                <div className="brand-panel">
                    <span className="brand-glow glow-1"></span>
                    <span className="brand-glow glow-2"></span>
                    <span className="brand-glow glow-3"></span>
                    <span className="brand-stars stars-1"></span>
                    <span className="brand-stars stars-2"></span>
                    <span className="brand-stars stars-3"></span>
                    <span className="brand-grid"></span>
                    <span className="brand-watermark-glow"></span>
                    <span className="brand-orbit orbit-1"></span>
                    <span className="brand-orbit orbit-2"></span>
                    <span className="brand-orbit-spin spin-1"><span className="brand-satellite"></span></span>
                    <span className="brand-orbit-spin spin-2"><span className="brand-satellite sat-purple"></span></span>
                    <i className="fa fa-globe brand-watermark" aria-hidden="true"></i>

                    <div className="brand-panel-header">
                        {this.props.app.logo
                            ? <img className="brand-logo-img" src={this.props.app.logo} alt="Logo" />
                            : <div className="brand-logo-mark"><i className="fa fa-phone" aria-hidden="true"></i></div>
                        }
                        <span>OBD Platform</span>
                    </div>

                    <div className="brand-panel-copy">
                        <h1>The complete <span className="brand-accent-text">outbound dialer</span> platform.</h1>
                        <p>Powerful, scalable and enterprise-ready outbound calling — from one unified control room.</p>
                    </div>

                    <div className="brand-feature-grid">
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-blue"><i className="fa fa-phone" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">2Cr+ outbound calls per hour</span>
                                <span className="brand-feature-desc">Massive scale. Unmatched dialing capacity.</span>
                            </div>
                        </div>
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-purple"><i className="fa fa-bullseye" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">Predictive &amp; progressive dialing</span>
                                <span className="brand-feature-desc">Higher connect rate, better productivity.</span>
                            </div>
                        </div>
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-green"><i className="fa fa-sitemap" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">Multi-level IVR &amp; multilingual TTS</span>
                                <span className="brand-feature-desc">Complex IVR flows with natural voice in multiple languages.</span>
                            </div>
                        </div>
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-amber"><i className="fa fa-shield" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">Built-in compliance checks</span>
                                <span className="brand-feature-desc">Stay compliant. Build trust. Protect your brand.</span>
                            </div>
                        </div>
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-purple"><i className="fa fa-bar-chart" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">Real-time CDR, analytics &amp; call monitoring</span>
                                <span className="brand-feature-desc">Live dashboards, actionable insights and complete call visibility.</span>
                            </div>
                        </div>
                        <div className="brand-feature-item">
                            <span className="brand-feature-icon icon-blue"><i className="fa fa-sitemap" aria-hidden="true"></i></span>
                            <div className="brand-feature-text">
                                <span className="brand-feature-title">Visual IVR &amp; campaign flow builder</span>
                                <span className="brand-feature-desc">Drag, drop and deploy campaign flows in minutes.</span>
                            </div>
                        </div>
                    </div>

                    <div className="brand-benefits-row">
                        <div className="brand-benefit-item">
                            <i className="fa fa-shield brand-benefit-icon icon-green" aria-hidden="true"></i>
                            <div className="brand-benefit-text">
                                <span className="brand-benefit-title">Enterprise Ready</span>
                                <span className="brand-benefit-desc">High availability, fault tolerant &amp; horizontally scalable architecture</span>
                            </div>
                        </div>
                        <div className="brand-benefit-item">
                            <i className="fa fa-cloud brand-benefit-icon icon-blue" aria-hidden="true"></i>
                            <div className="brand-benefit-text">
                                <span className="brand-benefit-title">Banking Grade Security</span>
                                <span className="brand-benefit-desc">Secure infrastructure and data protection</span>
                            </div>
                        </div>
                        <div className="brand-benefit-item">
                            <i className="fa fa-lock brand-benefit-icon icon-green" aria-hidden="true"></i>
                            <div className="brand-benefit-text">
                                <span className="brand-benefit-title">End-to-End Encrypted</span>
                                <span className="brand-benefit-desc">All data and calls are encrypted in transit and at rest</span>
                            </div>
                        </div>
                        <div className="brand-benefit-item">
                            <i className="fa fa-code brand-benefit-icon icon-amber" aria-hidden="true"></i>
                            <div className="brand-benefit-text">
                                <span className="brand-benefit-title">API First Platform</span>
                                <span className="brand-benefit-desc">Powerful APIs for seamless integrations and automation</span>
                            </div>
                        </div>
                        <div className="brand-benefit-item">
                            <i className="fa fa-headphones brand-benefit-icon icon-purple" aria-hidden="true"></i>
                            <div className="brand-benefit-text">
                                <span className="brand-benefit-title">24x7 Support</span>
                                <span className="brand-benefit-desc">Expert support whenever you need us.</span>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Right — login form */}
                <div className="auth-form-panel">
                    <span className="form-accent form-accent-top"></span>
                    <span className="form-accent form-accent-bottom"></span>
                    <div className="auth-form-wrapper">
                        <div className="auth-mobile-brand">
                            {this.props.app.logo
                                ? <img className="brand-logo-img" src={this.props.app.logo} alt="Logo" />
                                : <div className="brand-logo-mark"><i className="fa fa-phone" aria-hidden="true"></i></div>
                            }
                            <span>OBD Platform</span>
                        </div>

                        <div className="auth-form-header">
                            <div className="auth-icon-circle"><i className="fa fa-phone" aria-hidden="true"></i></div>
                            <h2>Sign in to your account</h2>
                            <p className="auth-subtitle">Welcome back — enter your details to continue.</p>
                        </div>

                        <Form onSubmit={this.loginUser} className="auth-form">
                            <Form.Group className="form-group" controlId='username'>
                                <Form.Label>Username</Form.Label>
                                <div className="input-with-icon">
                                    <i className="fa fa-user field-icon" aria-hidden="true"></i>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        placeholder="Enter your username"
                                        value={this.state.username}
                                        onChange={this.setvalue}
                                        className="input"
                                        required
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group className="form-group" controlId='password'>
                                <div className="form-label-row">
                                    <Form.Label>Password</Form.Label>
                                    {this.origin === this.props.app.reportPath && (
                                        <a href={`/reset-pwd`} className="forgot-link">Forgot password?</a>
                                    )}
                                </div>
                                <div className="password-input-container input-with-icon">
                                    <i className="fa fa-lock field-icon" aria-hidden="true"></i>
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder="Enter your password"
                                        value={this.state.password}
                                        onChange={this.setvalue}
                                        className="input password-input"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={this.togglePasswordVisibility}
                                        className="toggle-password-btn"
                                    >
                                        {showPassword ?
                                            <i className="fa fa-eye-slash" aria-hidden="true"></i> :
                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                        }
                                    </button>
                                </div>
                            </Form.Group>

                            <Button type="submit" className="submit-btn">
                                Sign In
                            </Button>
                        </Form>

                        <div className="auth-footer-note">
                            <div><i className="fa fa-lock" aria-hidden="true"></i> Protected by industry-standard encryption</div>
                            <div className="auth-footer-subnote">Your data is safe and secure with us.</div>
                        </div>

                        <div className="auth-cert-row">
                            <div className="auth-cert-badge">
                                <span className="auth-cert-icon cert-bg-red"><i className="fa fa-certificate" aria-hidden="true"></i></span>
                                <div className="auth-cert-text">
                                    <span>ISO 27001:2022</span>
                                    <span className="auth-cert-sub">Certified</span>
                                </div>
                            </div>
                            <div className="auth-cert-badge">
                                <span className="auth-cert-icon cert-bg-blue"><i className="fa fa-certificate" aria-hidden="true"></i></span>
                                <div className="auth-cert-text">
                                    <span>ISO 9001:2015</span>
                                    <span className="auth-cert-sub">Certified</span>
                                </div>
                            </div>
                            <div className="auth-cert-badge">
                                <span className="auth-cert-icon cert-bg-purple"><i className="fa fa-shield" aria-hidden="true"></i></span>
                                <div className="auth-cert-text">
                                    <span>Enterprise Grade</span>
                                    <span className="auth-cert-sub">Platform</span>
                                </div>
                            </div>
                            <div className="auth-cert-badge">
                                <span className="auth-cert-icon cert-bg-amber"><i className="fa fa-building" aria-hidden="true"></i></span>
                                <div className="auth-cert-text">
                                    <span>Reliable &amp; Highly</span>
                                    <span className="auth-cert-sub">Available</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Login);
